<template>
  <b-button-group>
    <b-button :variant="changeColor" :style="{ background: color, borderColor: color, color: 'black' }">{{
      text
    }}</b-button>
  </b-button-group>
</template>

<script>
export default {
  name: "ColorTestButtons",
  props: {
    color: { type: String, default: "black" },
    text: { type: String, default: "" },
  },
  data() {
    return {
      result: "",
      colorStyle: {
        
      },
    };
  },
  methods: {
    changeBackgroundColor() {
      const vm = this;
      console.warn("Mouse is hover!")
      this.colorStyle.background = vm.color
      this.colorStyle.color = 'black';
      this.colorStyle.borderColor = vm.color
    },
    originalBackgroundColor() {
      const vm = this;
      console.warn("Mouse is hover!")
      this.colorStyle.color = vm.color;
      this.colorStyle.background = "white"
    },
  },
  computed: {

    changeColor() {
      const vm = this;

      var result = "";
      console.info(vm.color);
      if (vm.color == "green") {
        result = "success";
        return result;
      }

      if (vm.color == "yellow") {
        result = "warning";
        return result;
      }

      if (vm.color == "red") {
        result = "danger";
        return result;
      }

      return result;
    },
    changeColorStyle() {
      const vm = this;
      var color = vm.colorStyle = {
        borderColor: vm.color,
        color: this.color,
        background: "white",
      }

      return color
    }
  },
  created() {
    this.originalBackgroundColor();
  },
};
</script>

<style scoped></style>
